var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: [_vm.namespace(), _vm.skinStyle] }, [
    _c(
      "div",
      { class: _vm.mdsNS("button-group") },
      _vm._l(_vm.dataModel, function(item) {
        return _c(
          "button",
          {
            key: item.id,
            class: _vm.btnClasses(item),
            attrs: { type: "button", value: item.id },
            on: {
              click: function($event) {
                return _vm.click(item)
              }
            }
          },
          [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }